import { render, staticRenderFns } from "./websitePointsOrderInfo.vue?vue&type=template&id=03c23eb0&scoped=true&"
import script from "./websitePointsOrderInfo.vue?vue&type=script&lang=js&"
export * from "./websitePointsOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./websitePointsOrderInfo.vue?vue&type=style&index=0&id=03c23eb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c23eb0",
  null
  
)

export default component.exports